export default __webpack_public_path__ + "static/media/testkit_wrapper.df719540.svg";